import { PageTitle } from 'src/ui/shared/components/page-components/PageTitle';

export const IdentityListPageNav = (): React.ReactElement<any, any> | null => {
    return <PageTitle>Switch Organisation</PageTitle>;
};
